const NOTIFY_URL = "https://formsubmit.co/ajax/cognitloop@gmail.com";

export async function subscribeBeta(email, source = "home") {
  const trimmed = email.trim();
  const res = await fetch(NOTIFY_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({
      email: trimmed,
      source,
      _subject: "CognitLoop beta signup",
      _template: "table",
      _captcha: "false",
      message: `${trimmed} asked to join the CognitLoop beta (${source}).`,
    }),
  });

  const data = await res.json().catch(() => ({}));
  const failed = data.success === false || data.success === "false";
  const activating = /activat/i.test(data.message || "");

  // First submit asks cognitloop@gmail.com to activate FormSubmit.
  // Treat that as success for the visitor — the signup already arrived.
  if (failed && !activating) {
    throw new Error(data.message || "Could not send. Please try again.");
  }
  if (!res.ok && !activating) {
    throw new Error(data.message || "Could not send. Please try again.");
  }
  return data;
}
